// copied from @mui/system/createStyled
function slotShouldForwardProp(prop){return prop!=='ownerState'&&prop!=='theme'&&prop!=='sx'&&prop!=='as';}export default slotShouldForwardProp;